module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6703/img/provider-signup/community-creators-image.png"